import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "@jkast90/kast-common/base.css";
import "@jkast90/kast-common/theme.css";
import "@jkast90/kast-common/tokens.css";
import "@jkast90/kast-common/ui.css";
import "./index.css";
import "./theme";
import { installFetchRecorder } from "@jkast90/kast-common/diagnostics";

// Before the first render, so every request lands in the bug report's API log.
installFetchRecorder();

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error('index.html has no element with id "root"');

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
